import { useState, useEffect } from 'react';
import { register } from '../serviceWorkerRegistration';

export default function useServiceWorkerUpdates() {
    const [waitingWorker, setWaitingWorker] = useState(null);

    useEffect(() => {
        register((registration) => {
            const worker = registration.waiting;
            if (worker) {
                setWaitingWorker(worker);
            }
        });
    }, []);

    const updateApp = () => {
        if (!waitingWorker) return;
        // Флаг обновления
        localStorage.setItem('app_updated', 'true');
        localStorage.setItem('sync_after_update', 'true');

        // Пытаемся очистить кэши перед перезагрузкой
        const hardReload = async () => {
            try {
                if ('caches' in window) {
                    const names = await caches.keys();
                    await Promise.all(names.map(n => caches.delete(n)));
                }
            } catch {}
            // Жёсткая перезагрузка с cache-busting
            window.location.replace('/?t=' + Date.now());
        };

        waitingWorker.postMessage({ type: 'SKIP_WAITING' });
        waitingWorker.addEventListener('statechange', (e) => {
            if (e.target.state === 'activated') {
                hardReload();
            }
        });
    };

    return { waitingWorker, updateApp };
}
